import { createSlice } from '@reduxjs/toolkit'
import {
  betListBlackjackGame, getBlackJackHighRollerTransactions, getBlackJackTransactions,
  getMyBlackJackTransactions, unfinishedBetBlackjackGame
} from 'games/BlackJack/slice-thunk/blackjack.thunk'
import { minus, plus } from 'number-precision'

const initialState = {
  loading: false,
  betsLoading: false,
  betList: null,
  unFinishedBet: null,
  blackjackTransactions: null,
  myBlackjackTransactions: null,
  blackjackHighRollerTransactions: null,
  wins: 0,
  losses: 0,
  profit: 0,
  wagered: 0,
  demoBetHistory: []
}

const {
  actions: {
    resetUnfinishedBet,
    setUpdateMyBet,
    setDemoMyBets,
    setBlackjackWinsCount,
    setBlackjackLossCount,
    setBlackjackProfit,
    setBlackjackWagered,
    resetLiveStats
  },
  reducer
} = createSlice({
  name: 'blackjack',
  initialState,
  reducers: {
    resetUnfinishedBet: (state, action) => ({
      ...state,
      unFinishedBet: null
    }),
    setUpdateMyBet: (state, action) => {
      return ({
        ...state,
        myBlackjackTransactions: action.payload
      })
    },
    setDemoMyBets: (state, action) => {
      return ({
        ...state,
        demoBetHistory: [action.payload, ...state.demoBetHistory]
      })
    },
    setBlackjackWinsCount: (state, action) => {
      return {
        ...state,
        wins: state.wins + 1
      }
    },
    setBlackjackLossCount: (state, action) => {
      return {
        ...state,
        losses: state.losses + 1
      }
    },
    setBlackjackProfit: (state, action) => {
      return {
        ...state,
        profit: plus(state.profit, minus(action.payload?.winningAmount ?? 0, action.payload?.betAmount ?? 0))
      }
    },
    setBlackjackWagered: (state, action) => {
      return {
        ...state,
        wagered: plus(state.wagered, action.payload)
      }
    },
    resetLiveStats: (state, action) => {
      return ({
        ...state,
        wins: 0,
        losses: 0,
        profit: 0,
        wagered: 0
      })
    }
  },
  extraReducers: builder => {
    builder
      .addCase(betListBlackjackGame.fulfilled, (state, { payload }) => ({
        ...state,
        betList: payload
      }))
      .addCase(unfinishedBetBlackjackGame.fulfilled, (state, { payload }) => ({
        ...state,
        unFinishedBet: payload
      }))
      .addCase(getBlackJackTransactions.pending, (state, action) => {
        return {
          ...state,
          betsLoading: true
        }
      })
      .addCase(getBlackJackTransactions.fulfilled, (state, action) => {
        return {
          ...state,
          blackjackTransactions: action?.payload,
          betsLoading: false
        }
      })
      .addCase(getBlackJackTransactions.rejected, (state, action) => {
        return {
          ...state,
          betsLoading: false
        }
      })
      .addCase(getMyBlackJackTransactions.pending, (state, action) => {
        return {
          ...state,
          betsLoading: true
        }
      })
      .addCase(getMyBlackJackTransactions.fulfilled, (state, action) => {
        return {
          ...state,
          myBlackjackTransactions: action?.payload,
          betsLoading: false
        }
      })
      .addCase(getMyBlackJackTransactions.rejected, (state, action) => {
        return {
          ...state,
          betsLoading: false
        }
      })
      .addCase(getBlackJackHighRollerTransactions.pending, (state, action) => {
        return {
          ...state,
          betsLoading: true
        }
      })
      .addCase(getBlackJackHighRollerTransactions.fulfilled, (state, action) => {
        return {
          ...state,
          blackjackHighRollerTransactions: action?.payload,
          betsLoading: false
        }
      })
      .addCase(getBlackJackHighRollerTransactions.rejected, (state, action) => {
        return {
          ...state,
          betsLoading: false
        }
      })
  }
})

export {
  resetUnfinishedBet,
  setUpdateMyBet,
  setBlackjackWinsCount,
  setBlackjackLossCount,
  setBlackjackProfit,
  setBlackjackWagered,
  resetLiveStats,
  setDemoMyBets
}

export default reducer
